'use client';

import { cn } from '../../lib/utils.js';
import { Section } from '../layout/Section.jsx';
import { Button } from '../ui/Button.jsx';
import { FadeIn } from '../animation/FadeIn.jsx';

/**
 * Call-to-Action Section component
 */
export function CTASection({
  headline,
  description,
  button,
  variant = 'dark',
  alignment = 'center',
  backgroundImage,
  className,
}) {
  const alignments = {
    left: 'text-left items-start',
    center: 'text-center items-center mx-auto mb-8',
    right: 'text-right items-end ml-auto',
  };

  return (
    <Section
      variant={variant}
      className={cn('relative overflow-hidden', className)}
    >
      {/* Background Image */}
      {backgroundImage && (
        <>
          <div className="absolute inset-0">
            <img
              src={backgroundImage}
              alt=""
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="absolute inset-0 bg-black/60" />
        </>
      )}

      <div className={cn('relative z-10 flex flex-col max-w-2xl', alignments[alignment])}>
        <FadeIn>
          {headline && (
            <h2 className={cn(
              'font-heading font-bold text-3xl md:text-4xl lg:text-5xl mb-6',
              variant === 'dark' || backgroundImage ? 'text-white' : 'text-primary dark:text-white'
            )}>
              {headline}
            </h2>
          )}
        </FadeIn>

        <FadeIn delay={0.1}>
          {description && (
            <p className={cn(
              'text-lg mb-8',
              variant === 'dark' || backgroundImage ? 'text-white/80' : 'text-gray-600'
            )}>
              {description}
            </p>
          )}
        </FadeIn>

        <FadeIn delay={0.2}>
          {button && (
            <Button
              href={button.href}
              variant={variant === 'dark' || backgroundImage ? 'white' : 'primary'}
              size="lg"
            >
              {button.label}
            </Button>
          )}
        </FadeIn>
      </div>
    </Section>
  );
}

export default CTASection;
